import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {RouterLink} from '@angular/router';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';
import {LanguageService} from '../services/language.service';
import {MetaService} from '../services/meta.service';
import {TitleService} from '../services/title.service';

@Component({
    selector: 'app-moon-information',
    templateUrl: './moon-information.component.html',
    imports: [
        RouterLink,
        TranslatePipe
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./moon-information.component.scss']
})
export class MoonInformationComponent implements OnInit {

    navSections = ['BASICS', 'PURPOSE', 'FUNCTION', 'SIGNS', 'NOTE'];
    phases = ['NEW', 'WAXING', 'FULL', 'WANING'];
    elements = ['FIRE', 'EARTH', 'AIR', 'WATER'];
    zodiacSigns = [
        'ARIES',
        'TAURUS',
        'GEMINI',
        'CANCER',
        'LEO',
        'VIRGO',
        'LIBRA',
        'SCORPIO',
        'SAGITTARIUS',
        'CAPRICORN',
        'AQUARIUS',
        'PISCES'
    ];
    recommendationAreas = ['GARDEN', 'HOUSEHOLD', 'CARE', 'NUTRITION', 'WELLBEING', 'HERBS', 'HOME'];
    dailyQuestions = ['FAVORABLE', 'TODO', 'WAIT'];
    formulaParts = ['PHASE', 'ZODIAC', 'ELEMENT', 'RECOMMENDATION'];
    processCards = ['PHASES', 'ZODIAC', 'ELEMENTS', 'SIGNS'];
    astronomyItems = ['PHASES', 'ORBIT', 'RISE_SET', 'POSITION', 'NEW_FULL'];
    traditionItems = ['CARE', 'GARDEN', 'NUTRITION', 'HOUSEHOLD', 'WELLBEING'];
    formulaIcons: Record<string, string> = {
        PHASE: 'assets/images/information/menu_phase.webp',
        ZODIAC: 'assets/images/information/menu_sign_2.webp',
        ELEMENT: 'assets/images/information/menu_element.webp',
        RECOMMENDATION: 'assets/images/information/menu_recommendation.webp'
    };
    exampleIcons: Record<string, string> = {
        PHASE: 'assets/images/moon/moon_5.webp',
        ZODIAC: 'assets/images/sign/virgo.webp',
        ELEMENT: 'assets/images/element/earth.webp'
    };
    elementIcons: Record<string, string> = {
        FIRE: 'assets/images/information/element_fire.webp',
        EARTH: 'assets/images/information/element_earth.webp',
        AIR: 'assets/images/information/element_air.webp',
        WATER: 'assets/images/information/element_water.webp'
    };
    zodiacIcons: Record<string, string> = {
        ARIES: 'assets/images/month/aries.webp',
        TAURUS: 'assets/images/month/taurus.webp',
        GEMINI: 'assets/images/month/gemini.webp',
        CANCER: 'assets/images/month/cancer.webp',
        LEO: 'assets/images/month/leo.webp',
        VIRGO: 'assets/images/month/virgo.webp',
        LIBRA: 'assets/images/month/libra.webp',
        SCORPIO: 'assets/images/month/scorpio.webp',
        SAGITTARIUS: 'assets/images/month/sagittarius.webp',
        CAPRICORN: 'assets/images/month/capricorn.webp',
        AQUARIUS: 'assets/images/month/aquarius.webp',
        PISCES: 'assets/images/month/pisces.webp'
    };

    constructor(
        private translate: TranslateService,
        private metaService: MetaService,
        private titleService: TitleService,
        public languageService: LanguageService
    ) {
    }

    ngOnInit(): void {
        this.setTitleAndMeta();
    }

    exampleIcon(part: string): string | undefined {
        return this.exampleIcons[part];
    }

    formulaIcon(part: string): string {
        return this.formulaIcons[part];
    }

    elementIcon(element: string): string {
        return this.elementIcons[element];
    }

    zodiacIcon(sign: string): string {
        return this.zodiacIcons[sign];
    }

    private setTitleAndMeta() {
        this.translate.get('TITLE.INFORMATION').subscribe((translated: string) => {
            this.titleService.updateTitleText(this.translate, translated);
        });

        this.translate.get('META.DESCRIPTION.INFORMATION').subscribe((translated: string) => {
            this.metaService.updateDescription(translated);
            this.metaService.updateCanonicalUrl('/information');
            this.metaService.updateSocialTags(
                this.translate.instant('TITLE.INFORMATION'),
                translated,
                '/information'
            );
        });

        this.translate.get('META.KEYWORDS.INFORMATION').subscribe((translated: string) => {
            this.metaService.updateKeywords(translated);
        });
    }
}
